function loadImageFromFile(file) {
    return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file);
        const image = new Image();

        image.onload = () => {
            URL.revokeObjectURL(objectUrl);
            resolve(image);
        };

        image.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error("Unable to load image for compression"));
        };

        image.src = objectUrl;
    });
}

function canvasToBlob(canvas, type, quality) {
    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (!blob) {
                    reject(new Error("Unable to generate compressed image"));
                    return;
                }
                resolve(blob);
            },
            type,
            quality,
        );
    });
}

function scaledSize(width, height, maxDimension) {
    if (width <= maxDimension && height <= maxDimension) {
        return { width, height };
    }

    if (width >= height) {
        const ratio = maxDimension / width;
        return {
            width: maxDimension,
            height: Math.max(1, Math.round(height * ratio)),
        };
    }

    const ratio = maxDimension / height;
    return {
        width: Math.max(1, Math.round(width * ratio)),
        height: maxDimension,
    };
}

function replaceFileExtension(fileName, nextExtension) {
    const normalized = String(fileName || "damage-photo").trim() || "damage-photo";
    const stripped = normalized.replace(/\.[^/.]+$/, "");
    return `${stripped}.${nextExtension}`;
}

export async function compressImageFile(file, { maxDimension = 1280, quality = 0.72, outputMimeType = "image/jpeg", outputExtension = "jpg" } = {}) {
    if (!(file instanceof File)) {
        throw new Error("Expected a file");
    }

    const image = await loadImageFromFile(file);
    const nextSize = scaledSize(image.naturalWidth || image.width, image.naturalHeight || image.height, maxDimension);

    const canvas = document.createElement("canvas");
    canvas.width = nextSize.width;
    canvas.height = nextSize.height;

    const context = canvas.getContext("2d");
    if (!context) {
        throw new Error("Unable to prepare image compression");
    }

    context.drawImage(image, 0, 0, nextSize.width, nextSize.height);

    const compressedBlob = await canvasToBlob(canvas, outputMimeType, quality);
    const compressedFile = new File([compressedBlob], replaceFileExtension(file.name, outputExtension), {
        type: outputMimeType,
        lastModified: Date.now(),
    });

    return {
        file: compressedFile,
        width: nextSize.width,
        height: nextSize.height,
    };
}
